/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { StatusLabel } from '@neo4j-ndl/react';

const Component = () => {
  return (
    <div className="n-grid n-grid-cols-6 n-grid-rows-2 n-gap-token-16 n-items-center n-justify-items-center">
      <StatusLabel variant="default" hasIcon>
        Default
      </StatusLabel>
      <StatusLabel variant="info" hasIcon>
        Info
      </StatusLabel>
      <StatusLabel variant="success" hasIcon>
        Success
      </StatusLabel>
      <StatusLabel variant="danger" hasIcon>
        Danger
      </StatusLabel>
      <StatusLabel variant="warning" hasIcon>
        Warning
      </StatusLabel>
      <StatusLabel variant="discovery" hasIcon>
        Discovery
      </StatusLabel>
      <StatusLabel variant="default" fill="clean" hasIcon>
        Default
      </StatusLabel>
      <StatusLabel variant="info" fill="clean" hasIcon>
        Info
      </StatusLabel>
      <StatusLabel variant="success" fill="clean" hasIcon>
        Success
      </StatusLabel>
      <StatusLabel variant="danger" fill="clean" hasIcon>
        Danger
      </StatusLabel>
      <StatusLabel variant="warning" fill="clean" hasIcon>
        Warning
      </StatusLabel>
      <StatusLabel variant="discovery" fill="clean" hasIcon>
        Discovery
      </StatusLabel>
    </div>
  );
};

export default Component;
